module.exports = __webpack_public_path__ + "img/20.7e7b2318.png";